import { declareString } from "@1js/localization";

export const AuthorLabel = declareString(
  "promptLibrary.promptPreviewAuthorLabel",
  {
    text: "Author",
    comment:
      "Label for the Copilot prompt's author component shown on the prompt card.",
  }
);
